import evAPI from '@util/api/ev';
import { client } from './contentfulClient';
import { fixLocale } from './page';

export interface Path {
  tags: any;
  current: string;
  title: string;
  id: string;
}

const api = new evAPI();

// promise style
export const getPressReleases = async (tags?: any, locale?: string): Promise<Path[]> => {
  if (locale == null || locale == 'en') locale = 'en-US';
  // convert tags from array to comma separated string
  const tagsInCommas = tags.join(',');
  const results = await client().getEntries({
    content_type: 'pressRelease',
    locale: fixLocale(locale),
    'metadata.tags.sys.id[in]': tagsInCommas,
    limit: 1000,
  });
  return results.items.map((page) => {
    // TODO: map Contentful types into TS types
    // @ts-ignore
    return {
      current: String(page.fields.slug) || '',
      title: String(page.fields.title) || '',
      id: String(page.sys.id) || '',
      tags: page.metadata.tags || [],
    };
  });
};

// promise style
export const getMediaCenterItems = async (
  mediaContentType: string,
  locale: string,
  limit?: number,
  offset?: number,
): Promise<any> => {
  if (locale == null || locale == 'en') locale = 'en-US';
  const clientEntries = await client().getEntries({
    content_type: mediaContentType,
    locale: fixLocale(locale),
    include: 10,
    skip: offset ? offset : 0,
    limit: limit ? limit : 18,
    order: ['-fields.publicationDate', '-sys.createdAt'],
  });
  return clientEntries;
};

// async await style
export const getPressReleaseDetailPageData = async (locale: string, slug: string): Promise<any> => {
  if (locale == null || locale == 'en') locale = 'en-US';
  const pressReleaseEntry = await client().getEntries({
    'fields.slug[in]': slug,
    content_type: 'pressRelease',
    limit: 1,
    include: 8,
    locale: fixLocale(locale),
  });

  return pressReleaseEntry;
};
